import type { MutableRefObject } from 'react';
import {
  proposeConstructionSourceMatches,
  type EstimateLoadData,
} from '../api/constructionPriceEstimatorFunctions';

/** Optional enrichment is fenced to the accepted draft and active workflow. */
export async function requestConstructionSourceMatchProposal({
  flowId, accepted, fence, isCurrent, reload,
}: {
  flowId: string;
  accepted: EstimateLoadData;
  fence: MutableRefObject<string | null>;
  isCurrent: () => boolean;
  reload: () => Promise<EstimateLoadData | null>;
}): Promise<void> {
  const draft = accepted.draft;
  if (!isCurrent() || !draft?.content_hash) return;
  const nextFence = `${draft.draft_revision}:${draft.content_hash}`;
  if (fence.current === nextFence) return;
  fence.current = nextFence;
  if (accepted.source_match_proposal?.candidates.length) return;
  try {
    const proposal = await proposeConstructionSourceMatches(
      flowId, draft.draft_revision, draft.content_hash,
    );
    if (isCurrent() && proposal?.candidates.length) await reload();
  } catch {
    // Contract Details remain saved and editable if enrichment is unavailable.
    if (isCurrent() && fence.current === nextFence) fence.current = null;
  }
}
